import * as React from 'react';

import { Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import FormHelperText from '@mui/material/FormHelperText';

export default function CustomInput({ name, control, label, rules, multiline, type }) {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <div className='flex gap-x-3 p-2'>
          <span className='p-1 w-36'>{label}</span>
          <TextField
            className='w-36'
            size='small'
            error={!!error}
            multiline={multiline ? multiline.enabled : false}
            rows={multiline ? multiline.rows : undefined}
            onChange={onChange}
            value={value || ""}
            variant='outlined'
            type={type ? type : 'text'}
          />
          <FormHelperText className='text-red-500'>{error?.message}</FormHelperText>
        </div>
      )}
    />
  );
}
